import { render } from "./FilesViewerDialog.vue?vue&type=template&id=5f8a0eba&scoped=true"
import script from "./FilesViewerDialog.vue?vue&type=script&lang=js"
export * from "./FilesViewerDialog.vue?vue&type=script&lang=js"

import "./FilesViewerDialog.vue?vue&type=style&index=0&id=5f8a0eba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8a0eba"]])

export default __exports__